import { render } from "./DashboardUsers.vue?vue&type=template&id=1cfc1db9&scoped=true"
import script from "./DashboardUsers.vue?vue&type=script&lang=js"
export * from "./DashboardUsers.vue?vue&type=script&lang=js"

import "./DashboardUsers.vue?vue&type=style&index=0&id=1cfc1db9&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfc1db9"]])

export default __exports__